import { gql } from '@apollo/client';

export const GET_INVITATION_FUNNELS = gql`
  query GetInvitationFunnels {
    vm {
      funnels {
        funnelId
        name
        isActive
      }
    }
  }
`;
